import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/login',
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
  {
    path: '/login',
    name: '登录',
    component: () => import('../views/login/login.vue'),
  },
  {
    path: '/class_list',
    name: '我的班级',
    component: () => import('../views/class_list/class_list.vue'),
  },
  {
    path: '/word_search',
    name: '搜字教学',
    component: () => import('../views/word_search/word_search.vue'),
  },
  {
    path: '/text_comment',
    name: '书写点评',
    component: () => import('../views/text_comment/text_comment.vue'),
  },
  {
    path: '/student_list',
    name: '学生列表',
    component: () => import('../views/student_list/student_list.vue'),
  },
  {
    path: '/task_list',
    name: '练习列表',
    component: () => import('../views/task_list/task_list.vue'),
  },
  {
    path: '/start_class',
    name: '课程观看',
    component: () => import('../views/start_class/start_class.vue'),
  },
]

const router = new VueRouter({
  routes,
})

export default router
